import type { VariantProps } from 'class-variance-authority';
import type { HTMLAttributes } from 'vue';

import { cva } from 'class-variance-authority';
import { type PrimitiveProps } from 'reka-ui';

export const textLinkVariants = cva(
	'cursor-pointer font-sans underline underline-offset-4 transition-colors',
	{
		variants: {
			variant: {
				default: 'decoration-white-dark-4 hover:decoration-primary',
				dark: 'decoration-primary-light-1 hover:decoration-white',
				'primary-light-1': 'decoration-primary-light-1 hover:decoration-primary'
			}
		},
		defaultVariants: {
			variant: 'default'
		}
	}
);

export type TextLinkVariantProps = VariantProps<typeof textLinkVariants>;
export interface TextLinkProps extends PrimitiveProps {
	class?: HTMLAttributes['class'];
	variant?: TextLinkVariantProps['variant'];
}

export { default as TextLink } from './TextLink.vue';
